module.exports = __webpack_public_path__ + "media/images/ecalls/03_reasons_understanding-8d8f36815bc77b4708b874fb5414796f.png";